import { tagsService } from "@/services/tagsService";
import type { Tag } from "@shared/schema";

/** Map tag display names to IDs; falls back to Supabase lookup for newly created tags. */
export async function resolveTagNamesToIds(
  tagNames: string[],
  knownTags: Tag[]
): Promise<string[]> {
  const ids: string[] = [];
  for (const name of tagNames) {
    const trimmed = name.trim();
    if (!trimmed) continue;
    let tag =
      knownTags.find((t) => t.name.toLowerCase() === trimmed.toLowerCase()) ?? null;
    if (!tag) {
      tag = await tagsService.getTagByName(trimmed);
    }
    if (tag) ids.push(tag.id);
  }
  return ids;
}
